import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "./config";
import Cookies from "js-cookie";


export const InvoiceListApi = createAsyncThunk(
    "member/invoiceList",
    async (data) => {
        const url = baseUrl + "invoiceList";
        const token = Cookies.get("token");

        try{
            const response = (await axios.post(url, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })).data
            console.log("response: ", response)
            if(response.status === "success"){
                return Promise.resolve(response);
            }else{
                return Promise.reject(response);
            }
        }catch(err){
            return Promise.reject(err);
        }
    }
)

export const InvoiceByIdApi = createAsyncThunk(
    "member/invoiceById",
    async(data) => {
        const url = baseUrl + "invoiceById";
        const token = Cookies.get("token");
        console.log(data);
        try{
            const response = (await axios.post(url, data, {
            headers: {
                Authorization: `Bearer ${token}`
            }
            
            })).data

            if(response.status === "success"){
                return Promise.resolve(response);
            }else{
                return Promise.reject(response);
            }
        }catch(err){
            return Promise.reject(err);
        }

        
    }
)

